import * as types from './types';

export const setForgotPasswordLoading = (isLoading = true) => ({
  type: types.PASSWORD_RECOVERY_SET_FORGOT_PASSWORD_LOADING,
  isLoading
});

export const setResetPasswordLoading = (isLoading = true) => ({
  type: types.PASSWORD_RECOVERY_SET_RESET_PASSWORD_LOADING,
  isLoading
});

export const sendRecoveryRequest = (email) => ({
  type: types.PASSWORD_RECOVERY_SEND_RECOVERY_REQUEST,
  email
});

export const setRecoveryRequestHasBeenSentToEmail = (recoveryRequestHasBeenSentToEmail) => ({
  type: types.PASSWORD_RECOVERY_SET_RECOVERY_REQUEST_HAS_BEEN_SENT_TO_EMAIL,
  recoveryRequestHasBeenSentToEmail
});

export const resetForgotPasswordState = () => ({
  type: types.PASSWORD_RECOVERY_RESET_FORGOT_PASSWORD_STATE
});

export const setRecoveryRequestFailedReason = (recoveryRequesFailedReason) => ({
  type: types.PASSWORD_RECOVERY_SET_RECOVERY_REQUEST_FAILED_REASON,
  recoveryRequesFailedReason
});

export const validateResetPasswordCode = (code) => ({
  type: types.PASSWORD_RECOVERY_VALIDATE_RESET_PASSWORD_CODE,
  code
});

export const resetPasswordByCode = (code, password) => ({
  type: types.PASSWORD_RECOVERY_RESET_PASSWORD,
  code,
  password
});

export const setPasswordSuccessfullyChanged = (passwordSuccessfullyChanged) => ({
  type: types.PASSWORD_RECOVERY_SET_PASSWORD_SUCCEFULLY_CHANGED,
  passwordSuccessfullyChanged
});

export const setCodeIsExpiredOrUsed = (codeIsExpiredOrUsed) => ({
  type: types.PASSWORD_RECOVERY_SET_CODE_IS_EXPIRED_OR_USED,
  codeIsExpiredOrUsed
});

export const setCodeIsNotFound = (codeIsNotFound) => ({
  type: types.PASSWORD_RECOVERY_SET_CODE_IS_NOT_FOUND,
  codeIsNotFound
});

export const resetResetPasswordState = () => ({
  type: types.PASSWORD_RECOVERY_RESET_RESET_PASSWORD_STATE
});



// WEBPACK FOOTER //
// ./src/actions/password-recovery/index.js